import { to } from "@lib/utils";
import { UploadParams } from "@models/storage";
import { apiClient } from "@providers/auth";
import axios from "axios";

const upload = async (file: File, key: string) => {
  const { res: getSignedURLRes } = await to(
    apiClient.get("/storage/upload-url", {
      key,
    })
  );
  if (!getSignedURLRes?.url) throw new Error("Error getting signed URL");
  const signedUrl: string = getSignedURLRes.url;

  const { res: uploadToSignedURLRes } = await to(
    axios.put(signedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    })
  );
  if (!uploadToSignedURLRes)
    throw new Error("Error uploading file to signed URL");

  const uploadedUrl = signedUrl.split("?")[0];
  return uploadedUrl;
};

export const uploadImage = async (file: File, key: string) => {
  return await upload(file, key);
};

const restrictedUploadMedia = async (
  file: File,
  uploadParams: UploadParams
) => {
  const formData = new FormData();
  formData.append("file", file);
  for (const key in uploadParams) {
    formData.append(key, uploadParams[key]);
  }

  const { res: uploadedUrl } = await to(
    apiClient.post(
      "/storage/media",
      formData,
      undefined,
      undefined,
      "multipart/form-data"
    )
  );
  return uploadedUrl;
};

export const restrictedUploadImage = async (
  file: File,
  uploadParams: UploadParams
) => {
  return await restrictedUploadMedia(file, uploadParams);
};
